import {createStore, combineReducers,applyMiddleware} from 'redux'
import Thunk from 'redux-thunk'
import {composeWithDevTools} from 'redux-devtools-extension'
import {
    registerReducer, 
    loginReducer,
    updateReducer,
    removeReducer,
    activateReducer,
    allUsersReducer,
    promoteReducer,
    publicAccountReducer,
    linkMemberReducer,
    resetPassLinkReducer,
    resetPasswordReducer,
} from './reducers/userReducer'

import {
    generateCSVReducer,
    generateDataReducer,
    memberInfoReducer,
    memberEditReducer,
    memberUploadAvatarReducer,
    memberNewReducer,
    allMembersReducer,
    exportSVGReducer,
    memberRelativesReducer,
    memberSearchByNameReducer,
    memberDeleteRelativesReducer,
    deleteMemberReducer
} from './reducers/memberReducer'

import {
    createPostReducer,
    listPostsReducer,
    getPostReducer,
    deletePostReducer
} from './reducers/blogReduces'

import {
    createDocumentReducer,
    listDocumentsReducer,
    getDocumentReducer,
    deleteDocumentReducer
} from './reducers/documentReducer'

import {
    createEventReducer,
    listEventsReducer,
    eventUnreadCountReducer,
    deleteEventReducer
} from './reducers/eventReducer'

import {
    createNotificationReducer,
    deleteNotificationReducer,
    listAdminNotificationsReducer,
    listNotificationsReducer,
    notificationUnreadCountReducer
} from './reducers/notificationReducer'
const reducers = combineReducers({
    // Users Reducer
    users:allUsersReducer,
    registration:registerReducer,
    login:loginReducer,
    update:updateReducer,
    remove:removeReducer,
    activate:activateReducer,
    promote:promoteReducer,
    publicAccount:publicAccountReducer,
    linkMember:linkMemberReducer,
    resetPassLink:resetPassLinkReducer,
    resetPassword:resetPasswordReducer,
    
    // Members Reducers
    members:allMembersReducer,
    generateCSV:generateCSVReducer,
    familyData: generateDataReducer,
    profile:memberInfoReducer,
    photoUpload:memberUploadAvatarReducer,
    exportSVG:exportSVGReducer,
    memberEdit:memberEditReducer,
    newMember:memberNewReducer,
    memberRelatives:memberRelativesReducer,
    memberSearch: memberSearchByNameReducer,
    relativeDelete:memberDeleteRelativesReducer,
    deleteMember:deleteMemberReducer,

    // Blog Reducers
    newPost:createPostReducer,
    news:listPostsReducer,
    post:getPostReducer,
    removePost:deletePostReducer,

    // Document Reducers
    newDocument:createDocumentReducer,
    documents:listDocumentsReducer,
    document:getDocumentReducer,
    removeDocument:deleteDocumentReducer,

    // Event Reducers
    newEvent:createEventReducer,
    events:listEventsReducer,
    eventUnread:eventUnreadCountReducer,
    removeEvent:deleteEventReducer,

    // Notification Reducers
    newNotification:createNotificationReducer,
    notifications:listNotificationsReducer,
    adminNotifications:listAdminNotificationsReducer,
    notificationUnread:notificationUnreadCountReducer,
    removeNotification:deleteNotificationReducer

})


const middleware = [Thunk] 

const userInLocalStorage = localStorage.getItem('user')
? JSON.parse(localStorage.getItem('user')) : null

const initSate = {
    login:{user:userInLocalStorage}
}

const store = createStore(
    reducers,
    initSate,
    composeWithDevTools(applyMiddleware(...middleware))
)


export default store
